import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SvgIconsModule } from '@anecdotes/design-system/svg-icons';
import { TranslateModule } from '@ngx-translate/core';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { LoadersModule } from '@anecdotes/design-system/loaders';
import { DirectivesModule } from '@anecdotes/design-system/directives';
import {
  CheckboxComponent,
  CheckboxGroupComponent,
  CopyTextFieldComponent,
  FileInputComponent,
  MultipleFileInputComponent,
  RadioButtonComponent,
  RadioButtonGroupComponent,
  TextAreaComponent,
  TextFieldComponent,
  ToggleComponent,
  MultiselectableListComponent,
  DatePickerHeaderComponent,
  DatePickerComponent,
  DateRangeComponent,
  RichTextareaComponent,
  EditableFieldComponent,
  ColorPickerPaletteComponent,
  ToggleBoxComponent,
} from './components';
import {
  AutocompleteComponent,
  ClearButtonComponent,
  ControlErrorsComponent,
  ControlHeaderComponent,
  IndexIconComponent,
  ControlPlaceholderComponent,
  CharactersCounterComponent,
} from './components/atoms';
import { UtilsModule } from '@anecdotes/design-system/utils';
import { QuillModule } from 'ngx-quill';
import { ButtonsModule } from '@anecdotes/design-system/buttons';
import { WindowHelperService } from '@anecdotes/utils';
import { ColorPickerModule } from 'ngx-color-picker';
import { DynamicFormModule } from '@anecdotes/dynamic-form';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SvgIconsModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatMenuModule,
    MatButtonModule,
    PerfectScrollbarModule,
    ReactiveFormsModule,
    NgbTooltipModule,
    TranslateModule.forChild(),
    DirectivesModule,
    MatDatepickerModule,
    MatNativeDateModule,
    LoadersModule,
    UtilsModule,
    QuillModule.forRoot(),
    ButtonsModule,
    ColorPickerModule,
    DynamicFormModule,
  ],
  declarations: [
    AutocompleteComponent,
    CheckboxComponent,
    CheckboxGroupComponent,
    CopyTextFieldComponent,
    FileInputComponent,
    MultipleFileInputComponent,
    RadioButtonComponent,
    RadioButtonGroupComponent,
    TextFieldComponent,
    TextAreaComponent,
    MultiselectableListComponent,
    ClearButtonComponent,
    DatePickerComponent,
    DateRangeComponent,
    DatePickerHeaderComponent,
    ControlHeaderComponent,
    ControlErrorsComponent,
    IndexIconComponent,
    ControlPlaceholderComponent,
    CharactersCounterComponent,
    ToggleBoxComponent,
    ToggleComponent,
    RichTextareaComponent,
    EditableFieldComponent,
    ColorPickerPaletteComponent,
  ],
  providers: [WindowHelperService],
  exports: [
    AutocompleteComponent,
    CheckboxComponent,
    CheckboxGroupComponent,
    CopyTextFieldComponent,
    FileInputComponent,
    MultipleFileInputComponent,
    RadioButtonComponent,
    RadioButtonGroupComponent,
    TextFieldComponent,
    TextAreaComponent,
    DatePickerComponent,
    DateRangeComponent,
    MultiselectableListComponent,
    ControlHeaderComponent,
    ControlErrorsComponent,
    ToggleComponent,
    ControlPlaceholderComponent,
    ToggleBoxComponent,
    RichTextareaComponent,
    EditableFieldComponent,
    ColorPickerPaletteComponent,
    IndexIconComponent,
  ],
})
export class FormControlsModule {}
